import React, { Component } from 'react';
import StockChart from './stock-chart.js';
import SocialFeed from './social-feed.js';
import OrderGrid from './order-grid.js';
import DividendGrid from './dividend-grid.js';
import NoteList from './note-list.js';
import _ from 'lodash';
import { db } from '../firebase';
import axios from 'axios';
import StatLegend from '../components/stat.js'

export default class PositionDetail extends Component {


    constructor() {
        super();
        this.state = {
            symbol: null,
            position: null,
            orders: null,
            dividends: [],
            selected_page: null,
            full_screen: false
        }
        this.onSelectedTabChanged = this.onSelectedTabChanged.bind(this);
        this.toggleScreenMode = this.toggleScreenMode.bind(this);

    }

    async componentDidMount() {

        this.loadSymbol(this.props.symbol);
    }

    async componentWillReceiveProps(nextProps) {

        if (this.state.symbol != nextProps.symbol) {

            this.loadSymbol(nextProps.symbol);
        }
    }

    async loadSymbol(symbol) {

        if ((!symbol) || symbol.length <= 0) {

            this.setState({
                symbol: null,
                position: null,
                orders: null,
                dividends: []
            });

        }
        else {
            await this.getPosition(symbol);
            let orders = await db.getOrdersBySymbol(symbol);
            this.setState({
                orders: orders
            });
            let dividends = await db.getDividendsBySymbol(symbol);
            this.setState({
                dividends: dividends
            });
        }
    }

    async getPosition(symbol) {


        let position_item = await db.getPosition(symbol);
        position_item.unrealized_gains = 0;
        position_item.today_change = 0;
        position_item.today_unrealized_gains = 0;
        this.setState({
            symbol: symbol,
            position: position_item,
            selected_page: 'Overview'
        });
        let data = await this.getData(symbol);
        this.setState({

            position: data
        });
        this.loadSparklines("5d");
        this.loadSparklines("1m");
        this.loadSparklines("6m");
        this.loadSparklines("1y");

    };

    async  getData(symbol) {

        let prices = await axios.get('https://api.iextrading.com/1.0/stock/market/batch?types=price,quote,stats,company&symbols=' + symbol);
        let position_item = this.state.position;
        position_item.unrealized_gains = 0;
        position_item.last_price = prices && prices.data && prices.data[symbol] ? prices.data[symbol].price : 0;
        position_item.today_unrealized_gains = position_item.last_price > 0 ? ((position_item.last_price - prices.data[symbol].quote.previousClose) * position_item.quantity) : 0;
        position_item.unrealized_gains = position_item.last_price > 0 ? ((position_item.last_price - position_item.price) * position_item.quantity) : position_item.quantity * position_item.price * -1;
        position_item.today_change = prices && prices.data && prices.data[symbol] ? prices.data[symbol].quote.changePercent : 0;
        if (prices.data[symbol]) {


            return {
                ...position_item, ...prices.data[symbol].company
                , ...prices.data[symbol].stats
                , ...prices.data[symbol].quote
                , ...prices.data[symbol].stats
            }


        }
        else {

            return position_item;
        }
    }



    async  loadSparklines(range) {

        let pos_item = this.state.position;

        //https://api.iextrading.com/1.0/stock/'+ pos_item.symbol+'/chart/1m
        let chart_data = await axios.get('https://api.iextrading.com/1.0/stock/' + pos_item.symbol + '/chart/' + range);
        if (chart_data && chart_data.data) {

            pos_item["chart" + range] = chart_data.data ? chart_data.data.map(a => { return a.close }) : null;
            this.setState({

                position: pos_item
            });
        }
    }


    loadNotes(symbol) {

    }

    toggleScreenMode() {


        this.setState({
            full_screen: !this.state.full_screen
        });
        this.props.toggleScreenMode();
    }
    onSelectedTabChanged(name) {

        if (this.state.page !== name) {

            if (name === 'Notes') {

                this.loadNotes(this.state.symbol);
            }
            this.setState({
                selected_page: name
            });
        }
    }
    render() {



        if (!this.state.position) {

            return <div></div>
        }
        else {

            let hasDiv = this.state.position.dividends ? true : false;
            let tags = [];//this.state.position.sector ? [this.state.position.sector, this.state.position.industry] : [];// ["income", "growth", "earnings soon"];
            let pages = hasDiv ? ["Overview", "Orders", "Dividends", "Notes", "Social"] : ["Overview", "Orders", "Notes", "Social"];
            let active_page = this.state.selected_page;
            let onPageChanged = this.onSelectedTabChanged;
            let invested_amount = this.state.position.price * this.state.position.quantity;
            let gain_net = (this.state.position.last_price - this.state.position.price) * this.state.position.quantity;
            let gain_percent = (gain_net * 100 / invested_amount).toFixed(2);
            let show_chart = active_page === 'Overview';


            return (
                <div className="ss-container-stacked">

                    <nav className={"navbar ss-fixed-row " + ((gain_percent > 0) ? "is-success" : (gain_net < 0 ? "is-danger" : "is-info"))} style={{ height: "72px" }}>
                        <div className="navbar-start">

                            {this.state.position.logo &&
                                <div class="navbar-item">
                                    <img src={this.state.position.logo} width="auto" height="28" />
                                </div>}

                            <div className="navbar-item">
                                <div>
                                    <p className={"title is-4 has-text-white"}>{this.state.position.companyName}</p>
                                    <p className={"subtitle is-5 has-text-light"}>{this.state.position ? this.state.position.symbol : ''}
                                        {tags && tags.length > 0 && tags.map(a => {

                                            return (<span className="tag is-info" style={{ marginLeft: "0.5rem" }}>{a}</span>);
                                        })}
                                    </p>
                                </div>

                            </div>
                        </div>
                        {invested_amount > 0 && <div className="navbar-end">
                            <div className="navbar-item">
                                <div style={{ textAlign: "right", marginRight: 10 }}>
                                    <p className="title is-4 has-text-white">${invested_amount.toFixed(2)}</p>
                                    <p className="subtitle is-5 has-text-light">{gain_percent + '% ( $' + gain_net.toFixed(2) + ')'}</p>
                                </div>
                                {this.props.toggleScreenMode != undefined &&
                                    <div class="field is-grouped">
                                        <p class="control">
                                            <a class={this.state.full_screen ? "button is-white  is-medium" : "button is-medium is-link is-inverted"}
                                                onClick={(e) => this.toggleScreenMode()}>
                                                <span class="icon">
                                                    <i class="fa fa-columns" aria-hidden="true" ></i>
                                                </span>
                                            </a>
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>}
                    </nav>
                    <div className="ss-fixed-row">
                        <div className="tabs is-medium is-left">
                            <ul>
                                {pages.map(function (item) {
                                    return <li className={(active_page && active_page === item) ? 'is-active' : ''}>
                                        <a onClick={(e) => onPageChanged(item)}>{item}</a>
                                    </li>
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="ss-flex-row" style={{display:"flex",flexDirection:"column"}}>
                        {show_chart == true &&
                            <div>
                                <div className="section ss-fixed-row" style={{ backgroundColor: "hsl(0, 0%, 96%)", paddingBottom: 0 }}>
                                    <div class="columns">

                                        {invested_amount > 0 && <div class="column">
                                            <StatLegend
                                                color={this.state.position.today_unrealized_gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={"$" + this.state.position.today_unrealized_gains.toFixed(2)}
                                                value_secondary={(this.state.position.today_change * 100).toFixed(2) + "%"}
                                                label="Today P/L" />
                                        </div>}
                                        {invested_amount === 0 && <div class="column">
                                            <StatLegend
                                                color={this.state.position.today_unrealized_gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={"$" + this.state.position.last_price.toFixed(2)}
                                                value_secondary={(this.state.position.today_change * 100).toFixed(2) + "%"}
                                                label="Today's Price" />
                                        </div>}

                                        {invested_amount > 0 && <div class="column">
                                            <StatLegend
                                                color={this.state.position.unrealized_gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={"$" + this.state.position.unrealized_gains.toFixed(2)}
                                                value_secondary={gain_percent + "%"}

                                                label="Unrealized P/L" />
                                        </div>}
                                        <div class="column">
                                            <StatLegend
                                                color={this.state.position.gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={"$" + this.state.position.gains.toFixed(2)}
                                                label="Realized P/L" />
                                        </div>
                                        {hasDiv && <div class="column">
                                            <StatLegend
                                                color={this.state.position.dividends > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={"$" + this.state.position.dividends.toFixed(2)}
                                                label="Dividends" />

                                        </div>}
                                    </div>
                                </div>
                                <div className="section ss-fixed-row" style={{ backgroundColor: "hsl(0, 0%, 96%)" }}>
                                    {<StockChart symbol={this.state.symbol} />}
                                </div>
                                <div className="section ss-fixed-row" style={{ backgroundColor: "hsl(0, 0%, 96%)" }}>
                                    <div class="columns">
                                        {this.state.position.day5ChangePercent && <div class="column">
                                            <StatLegend
                                                color={this.state.position.day5ChangePercent > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={(this.state.position.day5ChangePercent * 100).toFixed(2) + "%"}
                                                label="5 Day Change"
                                                sparkline_data={this.state.position.chart5d} />
                                        </div>}
                                        {this.state.position.month1ChangePercent && <div class="column">
                                            <StatLegend
                                                color={this.state.position.month1ChangePercent > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={(this.state.position.month1ChangePercent * 100).toFixed(2) + "%"}
                                                label="1 Month Change"
                                                sparkline_data={this.state.position.chart1m} />
                                        </div>}
                                        {this.state.position.month6ChangePercent && <div class="column">
                                            <StatLegend
                                                color={this.state.position.month6ChangePercent > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={(this.state.position.month6ChangePercent * 100).toFixed(2) + "%"}
                                                label="6 month change"
                                                sparkline_data={this.state.position.chart6m} />

                                        </div>}
                                        {this.state.position.year1ChangePercent && <div class="column">
                                            <StatLegend
                                                color={this.state.position.year1ChangePercent > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                                value={(this.state.position.year1ChangePercent * 100).toFixed(2) + "%"}
                                                label="1 Year change"
                                                sparkline_data={this.state.position.chart1y} />

                                        </div>}
                                    </div>
                                </div>
                            </div>
                        }
                        <section class="section ss-flex-row" style={{ backgroundColor: "hsl(0, 0%, 96%)"}}>

                            {!show_chart && <div className="card" style={this.state.selected_page==="Social"? {height:"100%"}: {}}>
                                <div>
                                    {(() => {
                                        switch (this.state.selected_page) {

                                            case "Orders":
                                                return <OrderGrid order_data={this.state.orders} hide_symbol_column={true} />;
                                            case "Social":
                                                return <SocialFeed symbol={this.state.symbol} />
                                            case "Dividends":
                                                return <DividendGrid div_data={this.state.dividends} hide_symbol_column={true} />
                                            case "Notes":
                                                return <NoteList symbol={this.state.symbol} />
                                            case "Overview":
                                                return <div />;
                                            default: return <div />;
                                        }
                                    })()}
                                </div>
                            </div>}
                        </section>
                    </div>
                </div>
            );
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/position-detail.js